@if( isClose() ){
<article class="inspection-banner ">
    <div class="container" aria-label="container" role="container">

        <span class="inspection-banner__info" role="contentinfo">
            <h4>{{ title() }}</h4>
            <p>{{ toastDescription() }}</p>
        </span>
        <button type="button" id="close-button" class="close-button" (click)="handleClose()" aria-label="Close">
            <img src="./assets/img/icon-close.png" alt="close">
        </button>
    </div>
</article>


}